import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields, fa } from "app/main/std";
import { omit } from "keautils";
import { DireccionComponent } from "app/features/componentes/direccion/direccion";
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
export const DireccionFacturacionComponent = obtenerComponenteDireccionColonia<models.FacturacionOnline>("IdColoniaFacturacionOnline", "DireccionFacturacionOnline", "Dirección de facturación");



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/direccionfacturaciononline.tsx